import { directus } from "../Config/ApiUrls";
import { Api } from "../Config/Requests";


export const requestproducts = async (data) => {
    let filter = data.data || !data?.id ? '' : `&filter[_or][0][category_id][id][_eq]=${data.id}`;
    data?.data?.forEach((item, index) => {
        filter += `&filter[_or][${index}][category_id][id][_eq]=${item.id}`;
    });
    const searchQuery = data.search ? `&search=${data.search}` : ''; // Conditionally add search
    const countdata = await Api.GetRequest(directus + `items/products?aggregate[countDistinct]=id${searchQuery}${filter}`);
    const products = await Api.GetRequest(
        directus + `items/products?limit=15&fields[]=cashback&fields[]=category_id&fields[]=name&fields[]=status&fields[]=product_image&fields[]=id&sort[]=id&page=${data.page}${searchQuery}${filter}`
    );

    const total = countdata.data.data[0].countDistinct.id
    const pages = Math.ceil(total / 25)
    return { ...products.data, total, pages }
};


const requestProductdetails = async (data) => {
    if (data.id !== undefined) {
        const details = await Api.GetRequest(directus + `items/products/${data.id}`);
        const attributes = await Api.GetRequest(directus + `items/products_attributes_1?fields[]=attributes_id.name&fields[]=attributes_id.id&fields[]=attributes_id.type&fields[]=id&filter[_and][0][products_id]=${data.id}`);
        const productd = details?.data?.data;
        const units = await Api.GetRequest(directus + `items/products_units?fields[]=units_id.id&fields[]=units_id.name&fields[]=id&filter[_and][0][products_id]=${data.id}`);
        Object.assign(productd, { units: units?.data?.data })
        const attributeData = await Promise.all(
            attributes?.data?.data.map(async (attr) => {
                const attri_name = attr?.attributes_id
                const attri_values = await Api.GetRequest(directus + `items/attribute_values?fields[]=attribute_id&fields[]=attribute_value&fields[]=product_id&fields[]=id&sort[]=id&filter[_and][0][attribute_id][_eq]=${attr.attributes_id.id}&filter[_and][1][product_id][products_id][id][_eq]=${data?.id}`);

                const fields = await Promise.all(
                    attri_values?.data?.data?.map(async (item) => {
                        if (!item?.attribute_value?.length) return null; // Skip empty arrays
                        const value = await Api.GetRequest(directus + `items/attribute_values_Values?fields[]=Values_id.name&fields[]=Values_id.id&fields[]=id&filter[_and][0][attribute_values_id]=${item?.id}`);
                        return { attri_name, fields: value.data.data };
                    })

                );
                return fields[0]
            })
        );
        Object.assign(productd, { fields: attributeData })
        return productd
    }
};

const requestfilteredProducts = async (data) => {
    let filter = ''
    data?.ids?.map((i, ind) => {
        filter += `&filter[_or][${ind}][attribute_value][Values_id][id][_eq]=${i}`
    })
    const prods = await Api.GetRequest(directus + `items/attribute_values?fields[]=product_id&filter[_and][0][attribute_id][id][_eq]=${data.attr}${filter}`)
    if (prods.data.data.length) {
        let fil = ''
        prods?.data?.data?.map(async (item, index) => {
            fil += `&fields[]=id&filter[_or][${index}][id]=${item.product_id}`

        })
        const prod = await Api.GetRequest(directus + `items/attribute_values_products?fields[]=products_id.name&fields[]=products_id.id&fields[]=products_id.product_image${fil}`)
        let arr = []

        prod?.data?.data?.map((item) => {
            arr.push(item.products_id)
        })
        return {
            data: arr
        };
    }
    return []
}

// Define All User APIs
const ProductsApiRequests = {
    requestproducts,
    requestProductdetails,
    requestfilteredProducts
};
export default ProductsApiRequests;